import * as React from 'react';
import { Button } from 'react-bootstrap';
import { OrganType } from '@nkr/enums/index';
import { useAppHookContext } from '@nkr/utils/rest-api';

interface IProps {
    show: boolean;
}

const DonorShieldReimbursementPolicies = (props: IProps) => {
    const { app: { site } } = useAppHookContext();

    if (!props.show) {
        return null;
    }

    let openLink = (link: string) => {
        window.open(link, '_blank');
    };

    return (
        <span style={{ display: 'inline-flex', alignItems: 'center', flexWrap: 'wrap', gap: 8, justifyContent: 'flex-end' }}>
            <label style={{ margin: 0 }}>
                Donor Shield Reimbursement Policies:
            </label>
            {site.organType != OrganType.Liver && (
                <Button style={{ marginRight: 0 }} bsStyle='danger' onClick={() => openLink('https://www.donorshield.com/policy')}>
                    Kidney
                </Button>
            )}
            <Button bsStyle='warning' onClick={() => openLink('https://www.donorshield.com/liverpolicy')}>
                Liver
            </Button>
        </span>
    );
};

export default DonorShieldReimbursementPolicies;
